<template>
  <p class="text-muted"><small><slot /></small></p>
</template>

<script>
export default {
  name: 'FormNote'
}
</script>